import { render, staticRenderFns } from "./CameraEditor.vue?vue&type=template&id=0456072c&"
import script from "./CameraEditor.vue?vue&type=script&lang=js&"
export * from "./CameraEditor.vue?vue&type=script&lang=js&"
import style0 from "./CameraEditor.vue?vue&type=style&index=0&id=0456072c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports